/**
 * cs-announcement-bar.js
 * Fade + slide-up/down transition.
 * Fixes background-tab race: pauses on visibilitychange, uses setTimeout
 * instead of double-rAF so it never desynchronises when the tab is hidden.
 */
(function () {
  'use strict';

  var bar = document.getElementById('cs-ann-bar');
  if (!bar) return;

  var dismissKey = 'cs_ann_' + (bar.dataset.dismissKey || 'v1');

  /* ── Already dismissed? Hide and bail ── */
  try {
    if (localStorage.getItem(dismissKey) === '1') {
      bar.hidden = true;
      return;
    }
  } catch (e) {}

  /* ── Slides & dots ── */
  var slides  = Array.from(bar.querySelectorAll('.cs-ann-slide'));
  var dots    = Array.from(bar.querySelectorAll('.cs-ann-dot'));
  var current = 0;
  var speed   = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
  var timer   = null;

  /* Hard-reset every slide to a known-clean state, then activate `idx` */
  function resetToSlide(idx) {
    slides.forEach(function (s) {
      s.classList.remove('cs-ann-slide--active', 'cs-ann-slide--exit');
      s.style.cssText = '';
    });
    dots.forEach(function (d) { d.classList.remove('cs-ann-dot--active'); });
    current = idx;
    slides[current].classList.add('cs-ann-slide--active');
    if (dots[current]) dots[current].classList.add('cs-ann-dot--active');
  }

  function goTo(next) {
    if (next === current) return;

    /* Exit current */
    slides[current].classList.remove('cs-ann-slide--active');
    slides[current].classList.add('cs-ann-slide--exit');

    var exiting = slides[current];
    setTimeout(function () {
      exiting.classList.remove('cs-ann-slide--exit');
    }, 350);

    if (dots[current]) dots[current].classList.remove('cs-ann-dot--active');

    current = next;

    /* Enter next — set starting state, then animate in via setTimeout.
       We deliberately avoid double-rAF here: rAF is suspended in background
       tabs, which causes multiple slides to queue up and all get --active
       the moment the user returns.  setTimeout(fn, 20) is throttled but
       never fully suspended, so the state stays consistent. */
    var entering = slides[current];
    entering.style.transition = 'none';
    entering.style.opacity    = '0';
    entering.style.transform  = 'translateY(8px)';

    setTimeout(function () {
      entering.style.transition = '';
      entering.style.opacity    = '';
      entering.style.transform  = '';
      entering.classList.add('cs-ann-slide--active');
    }, 20);

    if (dots[current]) dots[current].classList.add('cs-ann-dot--active');
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  function startTimer() {
    if (!timer) timer = setInterval(next, speed);
  }

  function stopTimer() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  if (slides.length > 1) {
    startTimer();

    /* Pause when the tab is hidden; reset + restart when it becomes visible.
       This prevents stale rAF callbacks from corrupting slide state. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else {
        resetToSlide(current);
        startTimer();
      }
    });
  }

  /* ── Close button ── */
  var closeBtn = bar.querySelector('.cs-ann-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      stopTimer();
      bar.hidden = true;
      try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
    });
  }

})();
